import { FC } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useMutation } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { UserEditRequestFormProps, UserRejectRequestFormInput } from './types';
import { useStyles } from './styles';
import { useForm, Controller } from 'react-hook-form';
import CloseIcon from '@material-ui/icons/Close';
import { TextField, Button, Grid, Modal, Paper, IconButton } from '@material-ui/core';
import { uid } from 'utils';

export const UserRejectRequestForm: FC<UserEditRequestFormProps> = ({
  open,
  refetch,
  handleClose,
  id,
  setId,
  type,
  defaultValue,
  label,
  payload,
}) => {
  const classes = useStyles();
  const {
    userEditRequestTableStore: { rejectChange, rejectAllChange },
    notificationStore: { openNotification },
  } = useStore();
  const updateUserRejectRequestReq = useMutation(
    (data: UserRejectRequestFormInput) => (type === 'all' ? rejectAllChange(id, data) : rejectChange(id, data)),
    {
      mutationKey: 'updateUserEditRequestReq',
      onSuccess: () => {
        openNotification('success', `Successfully updated`);
        refetch();
        reset();
        handleClose();
      },
      onError: () => openNotification('error', `Can't update user`),
    }
  );
  useAppPreloader(updateUserRejectRequestReq.isLoading);
  const { control, handleSubmit, reset } = useForm<any>();
  const onSubmit = (data: any) => {
    if (payload?.customAttribute.length > 0) {
      const finalPayload = {
        reason: data.reason,
        customAttribute: payload?.customAttribute || [],
      };
      updateUserRejectRequestReq.mutate(finalPayload);
    } else {
      updateUserRejectRequestReq.mutate(data);
    }
  };
  return (
    <Modal className={classes.modal} disablePortal disableEnforceFocus disableAutoFocus open={open}>
      <Paper className={classes.paper} elevation={3}>
        <Grid container justify='space-between' alignItems='center'>
          <p className={classes.label}>Reason for Rejection</p>
          <IconButton
            style={{ marginRight: -16 }}
            onClick={() => {
              reset();
              setId(null);
              handleClose();
            }}
          >
            <CloseIcon color='primary' />
          </IconButton>
        </Grid>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid key={uid()} container justify='space-between'>
            <Controller
              name='reason'
              render={({ field, fieldState: { invalid } }) => (
                <TextField
                  {...field}
                  className={classes.textField}
                  label='Reason'
                  required
                  multiline
                  rows={4}
                  error={invalid}
                  autoComplete='fname'
                  helperText={invalid ? 'Required field' : ''}
                  inputProps={{
                    maxLength: 250,
                  }}
                />
              )}
              control={control}
            />
          </Grid>
          <Button className={classes.btn} type='submit' fullWidth variant='contained' color='primary'>
            REJECT & NOTIFY USER
          </Button>
          <Button variant='contained' color='default' className={classes.cancelButton} fullWidth onClick={handleClose}>
            Cancel
          </Button>
        </form>
      </Paper>
    </Modal>
  );
};
